import React from 'react';
import { CgChevronDown, CgChevronLeft } from 'react-icons/cg';

const menuData = [
    {
        title: 'Home',
        path: '/',
        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,
    },

    {
        title: 'Gallery',
        path: '/gallery',
    },

    {
        title: 'About Us',
        path: '/about',
    },

    /*{
        title: 'Pages',
        path: '/',

        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,

        subNav: [
            {
                title: 'Team',
                path: '/team',
                cName: 'sub-nav',
            },
            {
                title: 'Faq',
                path: '/faq',
                cName: 'sub-nav',
            },
            {
                title: 'Projects',
                path: '/projects',
            },
        ],
    },*/

    {
        title: 'Contact Us',
        path: '/contact',
    },
];

export default menuData;
